import React, { memo } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { IShipperContact } from '../utils/normalizeShipperContacts'
import { ContactRow } from './ContactRow'

const useContactListStyles = makeStyles(theme => ({
  contactsList: {
    display: 'grid',
    gap: theme.spacing(0, 3),
    gridTemplateColumns: 'repeat(5, min-content)',
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'auto auto auto auto 2fr',
      gap: theme.spacing(0, 6),
    },
    '& p.MuiTypography-body1': {
      padding: '2px 0',
    },
  },
}))

interface IContactListProps {
  contacts: IShipperContact[]
  noContactsMessage?: string
}

const ContactsList = memo<IContactListProps>(({ contacts, noContactsMessage }) => {
  const classes = useContactListStyles()

  return (
    <div>
      {contacts?.length ? (
        <div className={classes.contactsList}>
          <Typography variant='caption' color='textSecondary'>
            Name
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            Role
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            Email
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            Phone
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            Notes
          </Typography>
          {contacts.map((contact, idx) => {
            const { id, role } = contact || {}
            return <ContactRow key={id || `${role}${idx}`} contact={contact} />
          })}
        </div>
      ) : (
        <Typography variant='subtitle2'>
          {noContactsMessage ?? 'There are no shipper contacts.'}
        </Typography>
      )}
    </div>
  )
})

export default ContactsList
